// Ritmo disco originale generato con Web Audio (nessun brano esterno).
export const BPM = 127;
const BEAT = 60 / BPM;
const ROOTS = [55, 49, 46.25, 49]; // A1, G1, F#1, G1 — una battuta ciascuna

let sharedCtx = null;
export function getAudioCtx() {
  if (!sharedCtx) {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    sharedCtx = new C();
  }
  return sharedCtx;
}

function noiseBuffer(ctx) {
  const b = ctx.createBuffer(1, ctx.sampleRate * 0.5, ctx.sampleRate);
  const d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
  return b;
}

function env(ctx, node, t, peak, dur) {
  node.gain.setValueAtTime(0.0001, t);
  node.gain.exponentialRampToValueAtTime(peak, t + 0.005);
  node.gain.exponentialRampToValueAtTime(0.0001, t + dur);
}

function kick(ctx, out, t) {
  const o = ctx.createOscillator(); const g = ctx.createGain();
  o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(45, t + 0.12);
  env(ctx, g, t, 0.9, 0.3);
  o.connect(g).connect(out); o.start(t); o.stop(t + 0.32);
}

function hat(ctx, out, noise, t, open) {
  const s = ctx.createBufferSource(); s.buffer = noise;
  const f = ctx.createBiquadFilter(); f.type = "highpass"; f.frequency.value = 7000;
  const g = ctx.createGain(); env(ctx, g, t, open ? 0.18 : 0.1, open ? 0.18 : 0.05);
  s.connect(f).connect(g).connect(out); s.start(t); s.stop(t + 0.2);
}

function clap(ctx, out, noise, t) {
  const s = ctx.createBufferSource(); s.buffer = noise;
  const f = ctx.createBiquadFilter(); f.type = "bandpass"; f.frequency.value = 1500;
  const g = ctx.createGain(); env(ctx, g, t, 0.35, 0.15);
  s.connect(f).connect(g).connect(out); s.start(t); s.stop(t + 0.2);
}

function bass(ctx, out, t, freq) {
  const o = ctx.createOscillator(); o.type = "sawtooth"; o.frequency.value = freq;
  const f = ctx.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 650;
  const g = ctx.createGain(); env(ctx, g, t, 0.28, BEAT / 2 - 0.02);
  o.connect(f).connect(g).connect(out); o.start(t); o.stop(t + BEAT / 2);
}

function stab(ctx, out, t, root) {
  [4, 5, 6].forEach((m) => {
    const o = ctx.createOscillator(); o.type = "square"; o.frequency.value = root * m;
    const g = ctx.createGain(); env(ctx, g, t, 0.035, 0.18);
    o.connect(g).connect(out); o.start(t); o.stop(t + 0.2);
  });
}

// Avvia il loop; onBeat(n) viene chiamato a tempo su ogni battito. Ritorna stop().
export function startDiscoBeat(onBeat) {
  const ctx = getAudioCtx();
  if (!ctx) return () => {};
  const out = ctx.createGain(); out.gain.value = 0.7; out.connect(ctx.destination);
  const noise = noiseBuffer(ctx);
  let step = 0; // ottavi
  let next = ctx.currentTime + 0.1;
  const timers = [];
  const iv = setInterval(() => {
    while (next < ctx.currentTime + 0.2) {
      const beat = Math.floor(step / 2);
      const root = ROOTS[Math.floor(beat / 4) % ROOTS.length];
      const off = step % 2 === 1;
      if (!off) {
        kick(ctx, out, next);
        if (beat % 2 === 1) clap(ctx, out, noise, next);
        const delay = Math.max(0, (next - ctx.currentTime) * 1000);
        timers.push(setTimeout(() => onBeat && onBeat(beat), delay));
      } else {
        hat(ctx, out, noise, next, true);
        if (beat % 4 === 1 || beat % 4 === 3) stab(ctx, out, next, root);
      }
      hat(ctx, out, noise, next, false);
      bass(ctx, out, next, off ? root * 2 : root);
      step += 1;
      next += BEAT / 2;
    }
  }, 50);
  return () => {
    clearInterval(iv);
    timers.forEach(clearTimeout);
    out.gain.setTargetAtTime(0, ctx.currentTime, 0.05);
    setTimeout(() => out.disconnect(), 400);
  };
}
